import { defineMessages } from 'react-intl';

export default defineMessages({
  lockedStore: {
    id: 'app.common.header.lockedStore',
    defaultMessage:
      'This account has been locked to {storeText}. However, you can still have your orders shipped anywhere in the world',
  },
});
